import React from 'react';
import Anchor from '../form-elements/Anchor';

function AccordionTitle({ children }) {
    return (
        <Anchor
            className="uk-accordion-title uk-tile uk-tile-secondary uk-padding-small uk-flex uk-flex-between"
            style={{ fontSize: '1rem' }}
        >
            {children}
        </Anchor>
    );
}

export default AccordionTitle;
